import React from 'react';
import { useSelector } from 'react-redux';
import ButtonAction from '../../../../../components/buttons/ButtonAction';
import { permissionObj } from '../../../../../Helpers/permission';
import { ATTENDANCE_SUBVIEW_MODEL } from '../Model/Model';
/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: Full Stack Developer
 *
 */
const SubViewOptions = ({ subView, changeSubViewManage }) => {
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);

    return (
        <div className='d-flex gap-3'>
            {(DEV || permission?.includes(permissionObj?.WEB_PAYROLL_POLICY_READ)) && (
                <ButtonAction
                    id='btn_svo_global'
                    name='global'
                    className={
                        ATTENDANCE_SUBVIEW_MODEL.OVERTIME_POLICIES.GLOBAL === subView
                            ? 'btn-outlined-secondary-600-100'
                            : 'btn-outlined-secondary-600-00'
                    }
                    disabled={false}
                    splitName={false}
                    onClick={() => {
                        changeSubViewManage(ATTENDANCE_SUBVIEW_MODEL.OVERTIME_POLICIES.GLOBAL);
                    }}
                />
            )}

            {(DEV || permission?.includes(permissionObj?.WEB_PAYROLL_POLICY_READ)) && (
                <ButtonAction
                    id='btn_svo_by_department'
                    name='by_department'
                    className={
                        ATTENDANCE_SUBVIEW_MODEL.OVERTIME_POLICIES.BY_DEPARTMENT === subView
                            ? 'btn-outlined-secondary-600-100'
                            : 'btn-outlined-secondary-600-00'
                    }
                    disabled={false}
                    splitName={false}
                    onClick={() => {
                        changeSubViewManage(ATTENDANCE_SUBVIEW_MODEL.OVERTIME_POLICIES.BY_DEPARTMENT);
                    }}
                />
            )}
        </div>
    );
};

export default SubViewOptions;
